import React, { useEffect, useState } from 'react'
import CommonVideoCard from '../common-video-card'
import CommonVideoCardItem from '../common-video-card/item'
import CommonTopTextCard from '../common-top-text-card'
import FloorTabTitle from 'Components/floor/floor-tab-title'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useInView } from 'react-intersection-observer'
import {
  getHomeVideo,
  getPGCVideoRank,
  getPGCCategoryList,
  PGC_CAGETORY_SROUCE,
  ICommonVideoData,
  ICommonContentRankItem,
} from '../../services/home'
import 'array-flat-polyfill'

const NAV_LIST = [
  {
    label: '大神评测官',
    link: 'https://www.dongchedi.com/video/groups/128',
  },
  {
    label: '38号车评中心',
    link: 'https://www.dongchedi.com/video/groups/111',
  },
  {
    label: '明星评测官',
    link: 'https://www.dongchedi.com/video/groups/144',
  },
  {
    label: '丈母娘唠车',
    link: 'https://www.dongchedi.com/video/groups/131',
  },
]

const decoratorVideoInfo = (item: ICommonVideoData) => {
  return {
    coverUrl: item.video_info.cover_url,
    videoDuration: item.video_info.video_duration,
    videoWatchCount: item.video_info.video_watch_count,
    videoSize: item.video_info.video_size,
  }
}

const decoratorColum = (item: ICommonVideoData) => {
  return {
    id: item.column.id,
    logo: item.column.logo,
    name: item.column.name,
    introduction: item.column.introduction,
    description: item.column.description,
    episode: item.column.episode,
    modify_time: item.column.modify_time,
    publish_time: item.publish_time,
  }
}

const renderSlider = (groups: any, activeIndex: number, breakPoint: any) => {
  return groups?.flat()?.map((item: any, index: number) => {
    const videoInfo = {
      coverUrl: item.video_info.cover_url,
      videoDuration: item.video_info.video_duration,
      videoWatchCount: item.video_info.video_watch_count,
    }

    const perViewItemsCount =
      (breakPoint?.slidesPerView || 1) * (breakPoint?.slidesPerColumn || 1)

    return (
      <SwiperSlide key={index}>
        <CommonVideoCardItem
          order={index % perViewItemsCount}
          activeIndex={activeIndex}
          itemTeaParams={{
            page_id: 'page_main_new',
            event_id: 'video_module_card_content',
            module_id: 'video_module',
          }}
          titleTeaParams={{
            page_id: 'page_main_new',
            event_id: 'video_module_card_title',
            module_id: 'video_module',
          }}
          title={item?.title}
          uniqueIdStr={item.unique_id_str}
          videoInfo={decoratorVideoInfo(item)}
          column={decoratorColum(item)}
        />
      </SwiperSlide>
    )
  })
}

const HomeVideo: React.FC<{ videoPGCRankData: ICommonContentRankItem[] }> = ({
  videoPGCRankData = [],
}) => {
  const [data, setData] = useState<ICommonVideoData[]>([])
  const [categoryListPGCData, setCategoryListPGCData] = useState<string[]>([])

  if (categoryListPGCData?.length > 10) {
    categoryListPGCData.length = 10
  }

  useEffect(() => {
    const init = async () => {
      const res = await Promise.all([
        getHomeVideo(null),
        getPGCCategoryList(null, PGC_CAGETORY_SROUCE.VIDEO),
      ])
      setData(res?.[0]?.video_list || [])
      setCategoryListPGCData(res?.[1])
    }
    init()
  }, [])

  const [ref, inView] = useInView({
    threshold: 0,
  })
  useEffect(() => {
    if (inView) {
      sendTeaCommEvent('show_event', {
        page_id: 'page_main_new',
        event_id: 'common_conponent_module',
        module_id: 'video_module',
      })

      sendTeaCommEvent('show_event', {
        page_id: 'page_main_new',
        event_id: 'common_conponent_module',
        module_id: 'video_rank_module',
      })
    }
  }, [inView])

  return (
    <div
      className="home-video-card tw-grid tw-grid-cols-40 tw-gap-x-12 fix-swiper-mutil-row-mt-16 "
      ref={ref}
      style={{ marginTop: 25 }}
    >
      <div className="tw-col-span-30 2xl:tw-col-span-32">
        <CommonVideoCard
          list={data}
          onTitleClick={() => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'video_module_title',
              module_id: 'video_module',
            })
          }}
          onNavItemClick={(item) => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'video_module_keywords',
              module_id: 'video_module',
              button_name: item.label,
            })
          }}
          titleObj={{
            link: '/video',
            label: '视频看车',
          }}
          navList={categoryListPGCData?.map((item, index) => ({
            link: `/video?hotTag=${item}`,
            label: item,
            className: index + 1 > 6 ? 'tw-hidden xl:tw-block' : '',
          }))}
          more="/video/groups"
          renderSlider={renderSlider}
          narrowScreenItemSize={6}
          wideScreenItemSize={10}
          swiperConfig={{
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 12,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            onSlideChange: () => {
              sendTeaCommEvent('clk_event', {
                page_id: 'page_main_new',
                event_id: 'video_module_change',
                module_id: 'video_module',
              })
            },
            breakpoints: {
              1920: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                slidesPerColumn: 2,
              },
            },
          }}
        />
      </div>
      <div className="tw-col-span-10 xl:tw-col-span-8">
        <FloorTabTitle
          title="视频排行榜"
          onTitleClick={() => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'video_rank_module_title',
              module_id: 'video_rank_module',
            })
          }}
        />
        <CommonTopTextCard
          teaParams={{
            page_id: 'page_main_new',
            event_id: 'video_rank_module_item',
            module_id: 'video_rank_module',
          }}
          list={videoPGCRankData?.map((item) => ({
            link: `/article/${item.group_id}`,
            id: item.group_id,
            title: item.title,
            viewCount: item.count,
          }))}
        />
      </div>
    </div>
  )
}

export default HomeVideo
